import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, History, Pencil, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CorreggiDescrizioneDialog } from "./CorreggiDescrizioneDialog";
import { fmtData, pill } from "./format";

const Storico = ({ storico }) => (
  <div className="border-t pt-3" data-testid="descrizione-storico">
    <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-slate-500 font-semibold mb-2"><History className="h-3.5 w-3.5" /> Storico modifiche</div>
    <ul className="space-y-1.5">{storico.map((m) => (
      <li key={m.id} className="text-xs text-slate-600 dark:text-slate-400" data-testid={`storico-${m.id}`}>
        <b>{m.azione === "RIPRISTINO" ? "Ripristino originale" : "Correzione"}</b> · {m.autore || "—"} · {fmtData(m.data)}{m.motivo ? ` · «${m.motivo}»` : ""}
      </li>
    ))}</ul>
  </div>
);

export const DescrizioneVoce = ({ voce, storico, puoModificare, onChange }) => {
  const [open, setOpen] = useState(false);
  const [showOrig, setShowOrig] = useState(false);
  const ripristina = async () => {
    if (!window.confirm("Ripristinare il testo originale importato dall'Excel?")) return;
    try {
      const { data } = await api.post(`/righe/${voce.id}/excel-descrizione/ripristina`);
      toast.success("Descrizione originale ripristinata");
      onChange(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <Card data-testid="excel-descrizione"><CardContent className="p-4 sm:p-6 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-xs uppercase tracking-widest text-amber-600 font-semibold mr-auto">Descrizione di lavoro</div>
        {voce.troncata && !voce.descrizione_corretta && <span className={`${pill} bg-rose-50 text-rose-700 border-rose-200 gap-1`} data-testid="descrizione-troncata-badge"><AlertTriangle className="h-3 w-3" /> Descrizione troncata nell'Excel</span>}
        {voce.descrizione_corretta && <span className={`${pill} bg-sky-50 text-sky-800 border-sky-200`} data-testid="descrizione-corretta-badge">Corretta manualmente</span>}
        {puoModificare && <Button size="sm" variant="outline" onClick={() => setOpen(true)} data-testid="descrizione-correggi-btn"><Pencil className="h-3.5 w-3.5 mr-1" /> Correggi</Button>}
        {puoModificare && voce.descrizione_corretta && <Button size="sm" variant="ghost" onClick={ripristina} data-testid="descrizione-ripristina-btn"><RotateCcw className="h-3.5 w-3.5 mr-1" /> Ripristina originale</Button>}
      </div>
      <p className="text-sm whitespace-pre-line leading-relaxed" data-testid="descrizione-attuale">{voce.descrizione}</p>
      {voce.troncata && !voce.descrizione_corretta && <p className="text-xs text-rose-700">Il testo termina a 700 caratteri nel file: può essere completato manualmente. Il completamento automatico da XPWE non è utilizzato.</p>}
      {voce.descrizione_corretta && (
        <div>
          <button type="button" className="text-xs text-sky-700 underline" onClick={() => setShowOrig(!showOrig)} data-testid="descrizione-originale-toggle">{showOrig ? "Nascondi testo originale" : "Mostra testo originale importato"}</button>
          {showOrig && <p className="mt-2 text-xs whitespace-pre-line bg-slate-50 dark:bg-slate-900 border rounded p-3 text-slate-600" data-testid="descrizione-originale">{voce.descrizione_originale}</p>}
        </div>
      )}
      {storico.length > 0 && <Storico storico={storico} />}
      {open && <CorreggiDescrizioneDialog open={open} onOpenChange={setOpen} voce={voce} onSaved={onChange} />}
    </CardContent></Card>
  );
};
